import type { TechnicalDomain } from '../types/profile'

export const technicalDomains: TechnicalDomain[] = [
  {
    index: '01',
    name: 'Aerospace & Defence Systems',
    description:
      'Detailed-part manufacture, prime and tier-one supply structures, and the assurance regimes that govern defence programmes.',
    systems: [
      'Sovereign capability assurance',
      'Tier-one supply chain architecture',
      'Defence acquisition frameworks',
      'Multi-site production transfer',
    ],
  },
  {
    index: '02',
    name: 'Advanced Materials & Decarbonisation',
    description:
      'Steel and materials processing routes, and the technology pathways that take heavy industry toward net zero.',
    systems: [
      'Electric arc and green steel routes',
      'Industrial decarbonisation pathways',
      'Pilot-to-production scale-up',
      'Research IP commercialisation',
    ],
  },
  {
    index: '03',
    name: 'Automotive & Propulsion',
    description:
      'Electrification of road and rail, and the industrialisation of the battery and propulsion supply base.',
    systems: [
      'Vehicle electrification programmes',
      'Battery industrialisation (UKBIC)',
      'Very light rail demonstration',
      'Next-generation propulsion',
    ],
  },
  {
    index: '04',
    name: 'Governance & Assurance Systems',
    description:
      'The codes, controls and reporting architecture through which a board actually exercises control.',
    systems: [
      'UK Corporate Governance Code',
      'Three lines of defence model',
      'Risk appetite and register design',
      'Board reporting and delegated authority',
    ],
  },
]
